import ImagePlaceholder from '../components/ImagePlaceholder';
import Footer from '../components/Footer';

export default function Gallery() {
  const placeholders = [
    { aspect: 'square' }, { aspect: 'portrait' }, { aspect: 'square' },
    { aspect: 'landscape' }, { aspect: 'square' }, { aspect: 'portrait' },
    { aspect: 'square' }, { aspect: 'landscape' }, { aspect: 'square' },
    { aspect: 'portrait' }, { aspect: 'square' }, { aspect: 'square' },
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="gallery-page">
      <section className="py-12 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl mb-4">Our Creations</h1>
            <p className="text-[var(--text-muted)] text-lg max-w-2xl mx-auto">
              A glimpse into our handcrafted desserts. More photos coming soon!
            </p>
          </div>

          {/* Masonry Grid */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6" data-testid="masonry-grid">
            {placeholders.map((item, index) => (
              <div key={index} className="break-inside-avoid" data-testid={`gallery-item-${index}`}>
                <ImagePlaceholder aspect={item.aspect} className="w-full" />
              </div>
            ))}
          </div>

          {/* Upload Note */}
          <div className="mt-16 max-w-2xl mx-auto text-center p-8 bg-gradient-to-br from-[var(--background-secondary)] to-white rounded-3xl border border-[var(--border-soft)]">
            <h3 className="text-2xl mb-4">Gallery Coming Soon!</h3>
            <p className="text-[var(--text-muted)] leading-relaxed">
              We're currently building our photo gallery. Check back soon to see our beautiful 
              custom creations, or follow us on Instagram for daily updates!
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}